export default __webpack_public_path__ + "static/media/resetPassword.c159854b.svg";